import React from 'react';
import { GrayArrow } from '../assets/svg';

interface RecommendedClassesProps {
  recomendedGroupClasses: {
    class_slug: string;
    class_title: string;
    class_day_time: string;
  }[];
}

const RecommendedClasses: React.FC<RecommendedClassesProps> = ({ recomendedGroupClasses }) => {
  const handleOpenClass = (slug: string) => {
    window.location.href = `/group-classes/${slug}`;
  };

  return (
    <section id="recomended-classes">
      <p className="text-[13px] font-normal leading-[normal] text-[#959595] mb-[6px]">
        Included in the above plans:
      </p>
      <div className="text-[16px] font-[550] leading-[normal] mb-[20px]">
        Recommended group classes
      </div>
      <div
        className="border border-[#EBEBEB] p-[20px] md:p-[25px] rounded-[18px] flex flex-col md:flex-row gap-[15px] md:gap-[28px]"
        style={{ boxShadow: '0 2px 4px 0 rgba(188, 188, 188, 0.12)' }}
      >
        {recomendedGroupClasses.slice(0, 2).map((classes, index) => {
          return (
            <div
              key={index}
              className="flex-1 bg-[#F2F2F2] px-[20px] py-[15px] rounded-[7px] flex justify-between items-center gap-[10px] cursor-pointer group"
              //   onClick={() => handleOpenClass(classes.class_slug)}
            >
              <div>
                <div className="text-[#171717] text-[12px] leading-[normal] font-medium mb-[6px]">
                  {classes.class_title}
                </div>
                <div className="text-[#848484] text-[11px] font-normal leading-[normal]">
                  {classes.class_day_time}
                </div>
              </div>
              <div>
                <GrayArrow />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default RecommendedClasses;
